{
  "ui": {
    "feedback": "Tagasiside",
    "credits": "Tegijad",
    "currentMaintainer": "Praegune haldaja",
    "maintainerPeriod": "Alates 2026. aastast",
    "originalTeam": "Algne meeskond",
    "creditsCampaigns": "Džungel ja jõulud",
    "moreSettings": "Veel seadeid",
    "chooseLanguage": "Vali keel",
    "notebookTools": "Vihiku tööriistad",
    "visualGuide": "Pildijuhend",
    "templeSoon": "Peagi tulekul",
    "playAdventure": "Mängi",
    "story": "Lugu",
    "loadingAdventure": "Valmistume seikluseks…",
    "storyOpening": "Kooliekskursioon džunglisse. Marco ja Sophia uurivad ümbrust koos sõpradega. Värviline lind köidab Marco tähelepanu ning ta järgneb talle puude vahele. Äkki on ta üksi. Aita avastajatel tee leida!",
    "storyEnding": "Marco ja Sophia jõuavad koos kadunud templini. Salapärane nägu valvab sissepääsu. Ees ootab uus seiklus!",
    "blockCategories": "Vihiku vahelehed",
    "actions": "Tegevused",
    "loops": "Tsüklid",
    "conditions": "Tingimused",
    "title": "Run Marco! — Seiklus sinu vihikus",
    "home": "Run Marco avaleht",
    "map": "Seikluskaart",
    "worlds": "Vali seiklus",
    "notebook": "Minu vihik",
    "notebookToggle": "Ava või sulge vihik",
    "notebookOpen": "Ava vihik",
    "notebookClose": "Vaata rada",
    "page": "Lehekülg {number}",
    "level": "Rada {number}",
    "run": "Lähme!",
    "stop": "Peata",
    "step": "Üks samm",
    "stepTitle": "Täida üks käsk",
    "reset": "Tagasi algusse",
    "add": "Lisa",
    "addLabel": "Vali lisatav plokk",
    "addHint": "Ühenda plokid ja vajuta Mängi.",
    "undo": "Võta tagasi",
    "clear": "Uus lehekülg",
    "hint": "Väike vihje",
    "help": "Kuidas mängida",
    "settings": "Seaded",
    "language": "Mängu keel",
    "blockLanguage": "Plokkide keel",
    "blockLanguageNote": "Plokkidele saad valida teise keele.",
    "musicOn": "Lülita heli sisse",
    "musicOff": "Lülita heli välja",
    "sound": "Muusika ja heliefektid",
    "speed": "Seikluse kiirus",
    "chooseExplorer": "Vali oma avastaja",
    "explorer": "Avastaja",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Sulge",
    "done": "Lähme avastama!",
    "loading": "Otsime rada…",
    "loadError": "Seiklust ei saanud laadida. Uuesti proovimiseks laadi leht uuesti.",
    "imageError": "Mõnda pilti ei saanud laadida. Laadi leht uuesti.",
    "gemGoal": "Leia kalliskivi",
    "goal": "Leia kuldne täht",
    "cover": "Süüta iga ruut ainult üks kord",
    "lit": "{count} / {total} ruutu valgustatud",
    "explored": "{count} / {total} rada avastatud",
    "facing": "Vaatab {direction} {arrow}",
    "boardLabel": "{name} rajal {level}, vaatab {direction}. {steps}. {objective}.",
    "up": "üles",
    "down": "alla",
    "left": "vasakule",
    "right": "paremale",
    "steps_one": "{count} samm",
    "steps_other": "{count} sammu",
    "blocks_one": "{count} plokk",
    "blocks_other": "{count} plokki",
    "stars_one": "{count} täht",
    "stars_other": "{count} tähte",
    "place": "Lisa plokke",
    "atEnd": "Lõppu",
    "insideRepeat": "Korduse {number} sisse",
    "insideIf": "Kui-ploki {number} sisse",
    "insideElse": "Muidu-ploki {number} sisse",
    "readyFirst": "Üks väike samm. Lisa edasiliikumise plokk ja lähme!",
    "ready": "Kuhu läheme? Tee vihikusse plaan.",
    "back": "Tagasi alguses. Sinu plokid on uueks katseks valmis.",
    "empty": "Lisa kõigepealt vihikusse üks plokk.",
    "win": "Leidsid tee!",
    "winCover": "Valgustasid raja!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Milline seiklus!",
    "simpler": "Kas saad hakkama vähemate plokkidega?",
    "complete": "Rada läbitud! Sinu parimad tähed on salvestatud.",
    "next": "Järgmine rada",
    "allWorlds": "Veel seiklusi",
    "replay": "Mängi uuesti",
    "shortGoal": "Peaaegu! Lisa veel plokke, et täheni jõuda.",
    "shortGem": "Peaaegu! Lisa veel plokke, et kalliskivini jõuda.",
    "shortCover": "Mõni ruut on veel pime. Kuidas sinna jõuame?",
    "checking": "Vaatame rada…",
    "paused": "Peatatud. Mängi alustab uuesti algusest.",
    "going": "Teel!",
    "stepped": "Sammu võrra lähemal. Jätkamiseks vajuta Üks samm või Mängi.",
    "clueCover": "Alusta servast ja läbi kogu kujund. Hüpe ületab ruudu seda valgustamata.",
    "clueCondition": "Vaata enda ees olevat rada. Tingimus aitab avastajal otsustada, mida teha.",
    "clueRepeat": "Millised sammud korduvad? Pane see muster kordusploki sisse.",
    "clueForward": "Edasi on suund, kuhu avastaja vaatab. Loe ruudud täheni kokku.",
    "clueGem": "Edasi on suund, kuhu avastaja vaatab. Loe ruudud kalliskivini kokku.",
    "clueTurn": "Pööramine muudab suunda ilma edasi liikumata. Jälgi rada sõrmega.",
    "mapNote": "Vali rada. Sinu parimad tähed jäävad alles.",
    "mapLevel": "Rada {number}: {name}. {stars}.",
    "locked": "Selle raja avamiseks lõpeta eelmine rada.",
    "soundBlocked": "Seikluse kuulmiseks puuduta helinuppu.",
    "clearTitle": "Kas alustame uut lehekülge?",
    "clearNote": "Selle raja plokid kustutatakse. Võta tagasi saab need taastada.",
    "keep": "Jäta minu plokid alles",
    "clearConfirm": "Kustuta plokid",
    "fresh": "Uus lehekülg. Kuhu viib meid sinu järgmine plaan?",
    "localProgress": "Sinu edenemine salvestatakse sellesse seadmesse.",
    "helpBuild": "Tee plaan",
    "helpBuildText": "Lohista plokid vihikusse ja ühenda need või lisa plokk seda puudutades. Tsüklisse sammude lisamiseks vali korduse sisse lisamine.",
    "helpTurn": "Järgne oma avastajale",
    "helpTurnText": "Edasi järgib tema pilku. Vasak ja parem pööravad kohapeal. Hüpe liigub kahe ruudu võrra.",
    "helpTry": "Proovi, vaata, proovi uuesti",
    "helpTryText": "Plaani proovimiseks vajuta Mängi, ühe käsu jaoks Üks samm. Kõver nool viib tagasi algusse ja jätab plokid alles.",
    "helpWorlds": "Igal seiklusel on eesmärk",
    "helpWorldsText": "Leia Džunglis kalliskivi. Jõuluseikluses valgusta iga vaba ruut üks kord. Templis ja Egeuse merel tee parandused, täida nähtavad eesmärgid ja jõua väljapääsuni.",
    "noTrail": "Seal pole rada! Proovi enne liikumist pöörata.",
    "broken": "See sild on katki. Kas saad sellest üle hüpata?",
    "blocked": "Miski on ees. Proovi hüpet või teist teed.",
    "alreadyLit": "See ruut juba põleb. Külasta iga ruutu ainult üks kord.",
    "loopError": "See plaan kordub lõputult. Proovi tsüklit muuta.",
    "repeatError": "Vali korduste arv vahemikus 1–99.",
    "unsupported": "Eemalda toetamata plokk ja proovi uuesti.",
    "connect": "Ühenda plokid üheks ahelaks ja vajuta Mängi.",
    "path": "rada",
    "backpack": "Seljakott",
    "templeGems": "Templi kalliskivid",
    "gemsCollected": "Kalliskivid: {count} / {total}",
    "gemsReady": "Kõik kalliskivid on kogutud!",
    "aegeanTitle": "Egeuse mere saladused",
    "harbour": "Sadam",
    "aegeanDescription": "Uuri sadamat: paranda tööpunkte, kasuta alamprogramme uuesti ja anna iga tööülesandega kaasa arv.",
    "templeBetaNote": "Beeta · Uuendame mõistatusi ja õppetunde",
    "aegeanBetaNote": "Beeta · Sadama esimesed 3 taset",
    "seasonal": "Hooajaline seiklus",
    "choosePreview": "Vali eelvaate tase",
    "repairs": "Parandused",
    "reachExit": "Jõua väljapääsuni",
    "taskRequirements": "Ülesande eesmärgid",
    "lessonGuided": "Juhendatud harjutus · täienda etteantud programmi",
    "lessonRepair": "Silumine · paranda etteantud programmi",
    "lessonChallenge": "Väljakutse · koosta oma programm",
    "acc_define_parameter": "Alamprogramm",
    "acc_call_argument": "Kutsu alamprogramm",
    "acc_repeat_parameter": "Korda sisendi järgi",
    "parameter": "parameeter",
    "argument": "saada",
    "callInput": "Selle kutse sisend",
    "inputWaiting": "Käivita programm või täida üks käsk korraga, et näha järgmist sisendit.",
    "argumentMismatch": "Parameetriga alamprogramm vajab arvuga kutset. Ilma parameetrita kasuta tavalist kutset.",
    "unsetParameter": "Kasuta parameetrit ainult alamprogrammis, mis selle vastu võtab. Parameetrid on ühismälust eraldi.",
    "memoryObjective": "Kontrolli paranduste arvestust ja väljapääsu nõudeid. Iga programm, mis need täidab, sobib.",
    "gate": "Tee on suletud. Kontrolli pooleliolevaid parandusi.",
    "noPickup": "Seisa tööriista kohal, enne kui selle üles võtad.",
    "creditLead": "Meeskonna juhtimine ja tarkvaraarendus",
    "creditArt": "Illustratsioonid ja keskkonnad",
    "creditAnimation": "Animatsioon",
    "creditUX": "Kasutajaliidese ja kasutajakogemuse disain",
    "creditDesign": "Mängudisain",
    "creditStory": "Loo kirjutamine",
    "creditAudio": "Muusika ja helitehnika",
    "lightLamp": "Süüta lamp",
    "oilLamp": "Õlilamp",
    "dustyStation": "tolmune tööpunkt",
    "betaLabel": "Beeta",
    "noLamp": "Seisa kustunud lambi kohal enne selle süütamist.",
    "collected": "Tööriist võetud · kasutusvalmis",
    "dustyPrompt": "Seisa tolmusel jaamal enne pintsli kasutamist.",
    "lampMissing": "Võta kõigepealt õlilamp. Vaata seljakotti.",
    "recursiveRoutine": "See alamprogramm kutsub iseennast. Kasuta teist alamprogrammi; rekursiivsed kutsed pole veel saadaval."
  },
  "content": {
    "jungle.title": "Džungliretk",
    "jungle.description": "Järgne rajale kadunud templini.",
    "jungle-1": "Esimesed sammud",
    "jungle-2": "Natuke kaugemale",
    "jungle-3": "Ümber nurga",
    "jungle-4": "Muuda suunda",
    "jungle-5": "Järgne rajale",
    "jungle-6": "Uus teekond",
    "jungle-7": "Uued rajad",
    "jungle-8": "Džungli ristmik",
    "jungle-9": "Leia oma tee",
    "jungle-10": "Mõtle ette",
    "jungle-11": "Pikk rada",
    "jungle-12": "Käänuline teekond",
    "jungle-13": "Julge hüpe",
    "jungle-14": "Mustrid ilmuvad",
    "jungle-15": "Korda rütmi",
    "jungle-16": "Vali rada",
    "jungle-17": "Vaata enne hüppamist",
    "jungle-18": "Loe rada",
    "jungle-19": "Nutikas ümbersõit",
    "jungle-20": "Puuvõrade all",
    "jungle-21": "Sillaehitaja",
    "jungle-22": "Teisel pool jõge",
    "jungle-23": "Avasta varemeid",
    "jungle-24": "Kivi ja puit",
    "jungle-25": "Suurem hüpe",
    "jungle-26": "Järgne vihjetele",
    "jungle-27": "Kõrgemale",
    "jungle-28": "Jätka avastamist",
    "jungle-29": "Looklevad rajad",
    "jungle-30": "Salajane aed",
    "jungle-31": "Peidetud mustrid",
    "jungle-32": "Muistsed rajad",
    "jungle-33": "Viimased pöörded",
    "jungle-34": "Templi poole",
    "jungle-35": "Peaaegu kohal",
    "jungle-36": "Kadunud tempel",
    "winter.title": "Talverada",
    "winter.description": "Jäta igasse jalajälge valgus.",
    "winter-1": "Sammud lumes",
    "winter-2": "Teine suund",
    "winter-3": "Jäätunud nurgad",
    "winter-4": "Pikk ring",
    "winter-5": "Lumehelves",
    "winter-6": "Talvetsüklid",
    "winter-7": "Jääavastaja",
    "winter-8": "Käänakud ja pöörded",
    "winter-9": "Jäine loogika",
    "winter-10": "Mustrite leidja",
    "winter-11": "Rajameister",
    "winter-12": "Talveime",
    "temple.title": "Kadunud tempel",
    "temple.description": "Nelikümmend ühendatud ruumi. Taasta taevane seade tööriistade, mälu ja enda alamprogrammidega."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Prügikast on tühi",
    "OPEN_TRASH": "Ava prügikast",
    "BLOCK_LABEL_BEGIN_STACK": "Ahela algus",
    "WORKSPACE_LABEL_1_STACK": "1 plokiahel",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 plokiahelat",
    "ARIA_TYPE_FIELD_NUMBER": "arv",
    "ARIA_TYPE_FIELD_DROPDOWN": "rippmenüü",
    "ARIA_TYPE_FIELD_IMAGE": "pilt",
    "WORKSPACE_LABEL_PLAIN": "Minu vihik",
    "FIELD_LABEL_EDIT_PREFIX": "Muuda: %1",
    "BLOCK_LABEL_HAS_INPUT": "sisaldab sisendit",
    "BLOCK_LABEL_HAS_INPUTS": "sisaldab sisendeid",
    "BLOCK_LABEL_HAS_BRANCHES": "harusid: %1",
    "FIELD_LABEL_OPTION_INDEX": "Valik %1",
    "INPUT_LABEL_EMPTY": "Tühi",
    "BLOCK_LABEL_DISABLED": "välja lülitatud",
    "BLOCK_LABEL_COLLAPSED": "kokku pakitud",
    "BLOCK_LABEL_BEGIN_PREFIX": "Algus: %1",
    "INPUT_LABEL_END_STATEMENT": "Lõpp: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "tekst",
    "ARIA_TYPE_FIELD_INPUT": "sisend",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "sisendi nimi",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "alamprogrammi nimi"
  }
}
